var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comment"},[_c('publish-comment',{ref:"publish-comment",attrs:{"type":_vm.type,"source-id":_vm.sourceId},on:{"call-back":_vm.setUpdateKey}}),_c('comment-list',{key:_vm.updateKey,attrs:{"type":_vm.type,"source-id":_vm.sourceId,"total-num":_vm.totalNum}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }